import { Theme } from '@mui/material/styles';
import { TypographyOptions } from '@mui/material/styles/createTypography';

const Typography = (theme: Theme, fontFamily: string): TypographyOptions => ({
    fontFamily,
    h6: {
        fontWeight: 500,
        color: theme.palette.grey[600],
        fontSize: '12px',
        letterSpacing: '-0.25px'
    },
    h5: {
        fontSize: '14px',
        color: theme.palette.grey[600],
        fontWeight: 500,
        letterSpacing: '-0.25px'
    },
    h4: {
        fontSize: '16px',
        color: theme.palette.grey[600],
        fontWeight: 600,
        letterSpacing: '-0.25px'
    },
    h3: {
        fontSize: '20px',
        color: theme.palette.grey[600],
        fontWeight: 600,
        letterSpacing: '-0.25px'
    },
    h2: {
        fontSize: '24px',
        color: theme.palette.grey[600],
        fontWeight: 700,
        letterSpacing: '-0.25px'
    },
    h1: {
        fontSize: '34px',
        color: theme.palette.grey[600],
        fontWeight: 700,
        letterSpacing: '-0.25px'
    },
    subtitle1: {
        fontSize: '14px',
        fontWeight: 500,
        color: theme.palette.text.dark,
        letterSpacing: '-0.25px'
    },
    subtitle2: {
        fontSize: '12px',
        fontWeight: 400,
        color: theme.palette.text.secondary,
        letterSpacing: '-0.25px'
    },
    caption: {
        fontSize: '12px',
        color: theme.palette.text.secondary,
        fontWeight: 400,
        letterSpacing: '-0.25px'
    },
    body1: {
        fontSize: '16px',
        fontWeight: 400,
        letterSpacing: '-0.25px'
        // lineHeight: '1.334em'
    },
    body2: {
        fontSize: '14px',
        fontWeight: 400,
        letterSpacing: '-0.25px',
        // lineHeight: '1.5em',
        color: theme.palette.text.primary
    },
    button: {
        textTransform: 'capitalize'
    },
    customInput: {
        marginTop: 1,
        marginBottom: 1,
        '& > label': {
            top: 23,
            left: 0,
            color: theme.palette.grey[500],
            '&[data-shrink="false"]': {
                top: 5
            }
        },
        '& > div > input': {
            padding: '30.5px 14px 11.5px !important'
        },
        '& > div > div': {
            padding: '30.5px 14px 11.5px !important'
        },
        '& legend': {
            display: 'none'
        },
        '& fieldset': {
            top: 0
        }
    },
    mainContent: {
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.dark[800] : theme.palette.primary.light,
        width: '100%',
        minHeight: 'calc(100vh - 88px)',
        flexGrow: 1,
        padding: '18px',
        marginTop: '88px',
        marginRight: '18px',
        borderRadius: '8px'
    },
    menuCaption: {
        fontSize: '14px',
        letterSpacing: '-0.25px',
        fontWeight: 500,
        color: theme.palette.grey[600],
        padding: '6px',
        textTransform: 'capitalize',
        marginTop: '10px'
    },
    subMenuCaption: {
        fontSize: '12px',
        fontWeight: 500,
        letterSpacing: '-0.25px',
        color: theme.palette.text.secondary,
        textTransform: 'capitalize'
    },
    commonAvatar: {
        cursor: 'pointer',
        borderRadius: '8px'
    },
    smallAvatar: {
        width: '22px',
        height: '22px',
        fontSize: '16px'
    },
    mediumAvatar: {
        width: '34px',
        height: '34px',
        fontSize: '18px'
    },
    largeAvatar: {
        width: '44px',
        height: '44px',
        fontSize: '20px'
    }
});

export default Typography;
